import React from 'react';
import styles from './specifications.module.scss';
import SpecificationsModel from '../../models/specifications';

type Props = {
  data: SpecificationsModel;
};

const Specifications = ({ data }: Props) => (
  <div className={styles.specifications}>
    <div className={styles.specifications__wrapper}>
      <div className={styles.specifications__content}>
        {data.categories &&
          data.categories.map((category: any) => (
            <div
              key={category.name}
              className={styles.specifications__category}
            >
              <h2 className={styles['specifications__category-title']}>
                {category.name}
              </h2>
              <div className={styles.specifications__tables}>
                {category.subcategories.map((subcategory: any) =>
                  subcategory.specs.map((s: any) => (
                    <div
                      key={`${s.name}-${s.value}`}
                      className={styles.specifications__cell}
                    >
                      <span className={styles.specifications__name}>
                        {s.name}
                      </span>
                      <span className={styles.specifications__value}>
                        {s.value}
                      </span>
                    </div>
                  ))
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  </div>
);

export default Specifications;
